import api from '../../plugins/api';

const editDeal = (payload) => {
  return api.post('/api/crm/deals/editDeal', payload);
};

export default editDeal;
